import customer from "./customer.component";
import CustomerTransforms from "./customer.transforms";
import customerUrls from "./customer.urls";

const customerModule = angular
  .module("app.components.customer", [])
  .component("customerPage", customer)
  .service("CustomerTransforms", CustomerTransforms)
  .config(customerUrls);

export default customerModule;



// WEBPACK FOOTER //
// ./src/pages/customer/customer.module.js